@switch (entry.type) {
  @case ('BackofficeStatus') {
    @if (entry?.oldValues?.length) {
      <p>Mainīts no "{{ entry.oldValues! | translate }}" uz "{{ entry.newValues! | translate }}"</p>
    } @else {
      <p>Izveidots ar vērtību "{{ entry.newValues! | translate }}"</p>
    }
  }

  @case ('ProcessingNotes'){
    <p>{{formatProcessingNotesChange()}}</p>
  }

  @case ('VisitTime') {
    {{ formatDateTimes() }}
  }

  @case ('MainInfo') {
    <p>{{ formatMainInfoChanges() }}</p>
  }

  @case ('ReadingRoom') {
    <p>Lasītava mainīta no "{{ entry.oldValues }}"" uz "{{entry.newValues}}"</p>
  }

  @case ('AttendanceStatus') {
    <p>
      {{ entry.newValues === 'NotAttended' ? ('components.table.notAttended' | translate) : ('components.table.attended' |
      translate) }}
    </p>
  }

  @case ('BackofficeNotes') {
    @if (tryParse(entry.newValues).backofficeNotes && tryParse(entry.newValues).Code) {
      <p>Mainīts uz "{{ tryParse(entry.newValues).backofficeNotes | translate }}" (GV kods: {{ tryParse(entry.newValues).Code
        }})</p>
    } @else {
      <p>{{ entry.newValues }}</p>
    }
  }
    @case ('CommunicationBackofficeFile') {
      <ng-container [ngTemplateOutlet]="fileCase"></ng-container>
    }
    @case ('CommunicationFrontofficeFile') {
      <ng-container [ngTemplateOutlet]="fileCase"></ng-container>
    }
    @case ('ClientNoteFile') {
      <ng-container [ngTemplateOutlet]="fileCase"></ng-container>
    }
    @case ('DoctoralCertificateFile') {
      <ng-container [ngTemplateOutlet]="fileCase"></ng-container>
    }
    @case ('TopicFile') {
      <ng-container [ngTemplateOutlet]="fileCaseNewFile"></ng-container>
    }
    @case ('TopicJustificationFile') {
      <ng-container [ngTemplateOutlet]="fileCaseNewFile"></ng-container>
    }
    @case ('NoteFile') {
      <ng-container [ngTemplateOutlet]="fileCase"></ng-container>
    }
  @case ('FirstSubmittedVersion') {
    <button class="secondary" (click)="show()">Sākotnējā pieteikuma versija</button>
    <ng-template #content let-c="close" let-d="dismiss">
      <div class="lna-modal-header">
        <h4 class="modal-title">Sākotnējā pieteikuma versija</h4>
        <button class="btn-close" (click)="close()" type="button" aria-label="Close"></button>
      </div>
      <div class="lna-modal-body">
        <app-service-summary [application]="newValues" [isModal]="true" />
      </div>
    </ng-template>
  }
  @case ('Communication') {
    <p>"{{ entry?.newValues }}"</p>
  }
  <!-- LNA-2061: the backend writes the whole sentence (which message, and when the client
       sent it), so print it verbatim instead of falling through to the JSON button. -->
  @case ('CommunicationRead') {
    <p>{{ entry?.newValues }}</p>
  }
  @case ('RestrictedAccessJustification') {
    <p>Pamatojums: "{{ entry?.newValues }}"</p>
  }
  @case ('ResponsibleUser') {
    @if (entry?.oldValues?.length) {
      <p>"{{ entry.oldValues! | translate }}" mainīts uz "{{ entry.newValues! | translate }}"</p>
    } @else {
      <p>Mainīts uz "{{ entry.newValues! | translate }}"</p>
    }
  }
  @case ('AttachmentExpirationDate') {
      @if (entry?.oldValues?.length && isTermChanged(entry)) {
        <p>{{ formatTermChange(entry) }}</p>
        <br />
      }
    <app-file-upload [associatedEntityId]="tryParse(entry.newValues).OuterId" [isEditMode]="false" [noPadding]="true" [showBackofficeNote]="isBackofficeNoteChanged(entry)"
    [type]="tryParse(entry.newValues).ObjectType" [existingFiles]="[keysToLowercase(tryParse(entry.newValues))]" />
  }
  @case ('StorageUnitCode') {
    <p>{{ entry.newValues }}</p>
  }

  @case ('ReaderCardEducationLevelInfo') {
    @if (entry?.oldValues?.length) {
      <p>Izglītība "{{ entry.oldValues! | translate }}" mainīts uz "{{ entry.newValues! | translate }}"</p>
    } @else {
      <p>Izveidots ar vērtību "{{ entry.newValues! | translate }}"</p>
      }
  }

  @case ('ReaderCardScientificDegreeInfo') {
    @if (entry?.oldValues?.length) {
      <p>Zinātniskais grāds "{{ entry.oldValues! | translate }}" mainīts uz "{{ entry.newValues ? ! (entry.newValues | translate) : '-' }}"</p>
    } @else {
      <p>Izveidots ar vērtību "{{ entry.newValues! | translate }}"</p>
    }
  }

  @default {
    <button class="secondary" (click)="show()">JSON</button>
    <ng-template #content let-c="close" let-d="dismiss">
      <div class="lna-modal-header">
        <h4 class="modal-title">Vērtības</h4>
        <button class="btn-close" (click)="close()" type="button" aria-label="Close"></button>
      </div>
      <div class="lna-modal-body">
        <pre>{{ entryJson }}</pre>
      </div>
    </ng-template>
  }
}
<ng-template #fileCase>
  @if (!entry.newValues) {
    <p>Datne dzēsta. Datnes nosaukums: <i class="small">{{tryParse(entry.oldValues).UploadFileName}}</i></p>
  } @else {
    <app-file-upload [associatedEntityId]="tryParse(entry.newValues).OuterId" [isEditMode]="false" [noPadding]="true"
      [type]="tryParse(entry.newValues).ObjectType" [existingFiles]="[keysToLowercase(tryParse(entry.newValues))]" />
  }
</ng-template>

<ng-template #fileCaseNewFile>
  @if (!entry.newValues) {
    <p>Datne dzēsta. Datnes nosaukums: <i class="small">{{tryParse(entry.oldValues).UploadFileName}}</i></p>
  } @else {
    <p>Datnes derīguma termiņš: {{tryParse(entry.newValues).FileNote.TermType === 'Indefinite' ? "'Beztermiņa'" :
    formatDate(tryParse(entry.newValues).FileNote.ValidTill)}}</p>
    <app-file-upload [associatedEntityId]="tryParse(entry.newValues).OuterId" [isEditMode]="false" [noPadding]="true"
      [type]="tryParse(entry.newValues).ObjectType" [existingFiles]="[keysToLowercase(tryParse(entry.newValues))]" />
  }
</ng-template>
